import { Router, NavigationEnd } from "@angular/router";
import { Component, OnDestroy } from "@angular/core";
import { Chart } from "chart.js";
import { SubSink } from "subsink";

import { GoogleAnalyticsService } from "@/core/services";
import {
  ConfigurationService,
  AuthenticationService,
} from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";
import { Userpilot } from "userpilot";

// https://medium.com/@PurpleGreenLemon/how-to-properly-add-google-analytics-tracking-to-your-angular-web-app-bc7750713c9e
declare let gtag;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnDestroy {
  dynamicFlag = false;
  rowNumbering = true;
  subs = new SubSink();

  // tslint:disable:max-line-length

  constructor(
    public router: Router,
    private googleService: GoogleAnalyticsService,
    private configurationService: ConfigurationService,
    private authenticationService: AuthenticationService,
  ) {
    Chart.defaults.global.plugins.datalabels.display = false;
    Userpilot.initialize("NX-83afb615");
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.googleService.record(
          "navigation",
          "navigate",
          "navigate to " + event.urlAfterRedirects,
        );
        gtag("config", "xx-xxxxx-xx", {
          page_path: event.urlAfterRedirects,
        });
        Userpilot.reload();
      }
    });

    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.subs.sink = this.configurationService.config.subscribe(
        (c: Configuration) => {
          this.dynamicFlag = c.highContrast;
          this.rowNumbering = c.useRowNumbering;
        },
      );
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
